import { get, put } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const loadApprovalLevels = (documentId, siteId) => get(`${url}/leasingDocument/${documentId}/${siteId}/approvalLevels`);
const updateApprovalLevel = (documentId, siteId, approvalLevel, isUpdateRequestedUserIdRequest) =>
  put(`${url}/leasingDocument/approvalLevels/update`, {
    documentId,
    siteId,
    approvalLevelId: approvalLevel.approvalLevelId,
    IsUpdateRequestedUserIdRequest: !!isUpdateRequestedUserIdRequest,
    approvalLevel
  });
const applyApprovalLevel = (documentId, siteId, approvalLevel) =>
  put(`${url}/leasingDocument/approvalLevels/apply`, { documentId, siteId, approvalLevel });
const loadApprovalsHistory = (documentId, siteId) =>
  get(`${url}/leasingDocument/${documentId}/${siteId}/approvalsHistory`);
const getApprovalTypeDecisionReasons = approvalTypeId =>
  get(`${url}/leasingDocument/${approvalTypeId}/approvalTypeDecisionReasons`);

const exp = {
  loadApprovalLevels,
  updateApprovalLevel,
  applyApprovalLevel,
  loadApprovalsHistory,
  getApprovalTypeDecisionReasons
};
export default exp;
